import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TransfercompletePage } from './transfercomplete';

@NgModule({
  declarations: [
    TransfercompletePage,
  ],
  imports: [
    IonicPageModule.forChild(TransfercompletePage),
  ],
})
export class TransfercompletePageModule {}



// WEBPACK FOOTER //
// ./src/pages/transfercomplete/transfercomplete.module.ts